module.exports = __webpack_public_path__ + "img/VALOR_PASION2.21fa0686.png";